import * as React from 'react';
import { useEffect, useRef } from 'react';
import PersianDatePicker from './Persian/MainBlock';
import NDate from '@nepo/ndate';
import './DatePicker.scss';

const DatePicker = props => {
  const [mainDate, setMainDate] = React.useState(null);
  const [showPicker, setShowPicker] = React.useState(false);
  const [displayValue, setDisplayValue] = React.useState({
    year: '',
    month: '',
    day: '',
  });
  const wrapperRef = useRef(null);
  const yearRef = useRef(null);
  const monthRef = useRef(null);
  const dayRef = useRef(null);

  // const changeShowPicker = (newValue) => {
  //   if (props.isEditDate) {
  //     setShowPicker(newValue);
  //   }
  // };

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current) {
        //@ts-ignore
        if (!wrapperRef.current.contains(event.target)) {
          // changeShowPicker(false);
          setShowPicker(false);
        }
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const toEnglishDigit = number => {
    console.log(number, typeof number);
    // return;
    var find = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    var replace = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    number.split('').forEach(n => {
      if (replace.some(arr => n === arr)) {
        return number;
      }
    });
    var replaceString = this;
    var regex;
    for (var i = 0; i < find.length; i++) {
      regex = new RegExp(find[i], 'g');
      number = number.replace(regex, replace[i]);
    }
    return number;
  };

  useEffect(() => {
    if (props.value) {
      if (props.value === ' ') {
        setMainDate(null);
      } else {
        const [year, month, day] = props.value.split(props.splitter);
        if (month === undefined) {
          setMainDate(new NDate(props.value));
        } else {
          const newDate = new NDate([+year, +month, +day]);
          setMainDate(newDate);
        }
      }
    }
  }, [props.value]);

  useEffect(() => {
    if (props.mainDate) {
      setMainDate(new NDate(props.mainDate));
    }
  }, [props.mainDate]);

  useEffect(() => {
    if (mainDate) {
      setDisplayValue({
        year: mainDate.yearJalali.toString(),
        month: ('0' + mainDate.monthJalali).slice(-2),
        day: ('0' + mainDate.dayJalali).slice(-2),
      });
    }
  }, [mainDate]);

  useEffect(() => {
    if (
      props.onChange &&
      displayValue.year.length === 4 &&
      displayValue.month.length === 2 &&
      displayValue.day.length === 2
    ) {
      const newDate = new NDate([
        +displayValue.year,
        +displayValue.month,
        +displayValue.day,
      ]).format('YYYY-MM-DD');
      props.onChange(newDate);
    }
  }, [displayValue]);

  const inputChangHandler = (name, value) => {
    const newResult = JSON.parse(JSON.stringify(displayValue));
    newResult[name] = value;
    if (name === 'year') {
      if (value.length === 4) {
        if (monthRef) {
          monthRef.current.focus();
          monthRef.current.select();
        }
      }
    } else if (name === 'month') {
      if (value.length === 2) {
        if (dayRef) {
          dayRef.current.focus();
          dayRef.current.select();
        }
      }
    }
    setDisplayValue(newResult);
  };

  const handleOnDateChange = value => {
    // min or max : YYYY-MM-DD
    if (props.min) {
      if (new NDate(props.min).date > value.date) {
        setMainDate(new NDate(props.min));
        return;
      }
    }
    if (props.max) {
      if (new NDate(props.max).date < value.date) {
        setMainDate(new NDate(props.max));
        return;
      }
    }

    setMainDate(value);
  };

  const handleResetDate = event => {
    event.stopPropagation();
    setMainDate('');
  };

  // console.log("isEditDate: ",props.isEditDate);

  return (
    <div className='datePicker' ref={wrapperRef}>
      {!props.marge && (
        <bdo
          dir='ltr'
          className='inputs'
          // onClick={() => setShowPicker(true)}
          onClick={() => {
            props.isEditDate === undefined || props.isEditDate
              ? setShowPicker(true)
              : setShowPicker(false);
          }}
        >
          <input
            type='text'
            value={displayValue.year}
            name='year'
            ref={yearRef}
            maxLength={4}
            placeholder='سال'
            style={{ borderRadius: '14px 0 0 14px' }}
            onChange={event => inputChangHandler('year', event.target.value)}
          />
          <input
            type='text'
            value={displayValue.month}
            name='month'
            ref={monthRef}
            maxLength={2}
            placeholder='ماه'
            onChange={event => inputChangHandler('month', event.target.value)}
          />
          <input
            type='text'
            value={displayValue.day}
            name='day'
            ref={dayRef}
            maxLength={2}
            placeholder='روز'
            style={{ borderRadius: '0 14px 14px 0' }}
            onChange={event => inputChangHandler('day', event.target.value)}
          />
        </bdo>
      )}
      {props.marge && (
        <>
          <input
            value={mainDate ? mainDate.formatJalali('YYYY/MM/DD') : ''}
            className='datePickerInput'
            // onClick={() => setShowPicker(true)}
            onClick={() => {
              props.isEditDate === undefined || props.isEditDate
                ? setShowPicker(true)
                : setShowPicker(false);
            }}
            style={{ borderRadius: '0.25rem', width: '100%' }}
            name={props.name}
            ref={props.elementRef}
            onChange={e => props.onChange(e.target.value)}
            placeholder={props.placeholder}
            readOnly
          />
          <span onClick={handleResetDate} className='clearBtn'>
            x
          </span>
        </>
      )}
      {showPicker && !props.miladi && (
        <PersianDatePicker
          mainDate={mainDate}
          onDaySelect={() => setShowPicker(false)}
          onDateChange={value => {
            handleOnDateChange(value);
          }}
        />
      )}
    </div>
  );
};

DatePicker.defaultProps = {
  splitter: '/',
};
export default DatePicker;
